import { Card, makeStyles } from "@material-ui/core";
import { BankIdSwitch } from "./components/bank-id-switch";
import { WelcomeEmailSwitch } from "./components/welcome-email-switch";
import { UnfitSwitch } from "./components/unfit-switch";

type Props = {
  consultantId: string;
};

export function Switches(props: Props) {
  const { root } = useStyles();
  return (
    <Card className={root}>
      <WelcomeEmailSwitch consultantId={props.consultantId} />
      <BankIdSwitch consultantId={props.consultantId} />
      <UnfitSwitch consultantId={props.consultantId} />
    </Card>
  );
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "15px"
  }
});
